var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.picList),function(item,idx){return _c('div',{key:idx},[_c('img',{staticClass:"img",attrs:{"src":item}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }